import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { Layout } from "./components/Layout";
import { Footer } from "./components/Footer";
import "./custom.css";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
const key = "6LfhN7wpAAAAAHgQ_duoPyToqJr0thDt_SOfGwph";
export default class App extends Component {
  static displayName = App.name;
  render() {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={key}>
        <GoogleReCaptcha
          className="google-recaptcha-custom-class"
          //onVerify={verifyRecaptchaCallback}
          //refreshReCaptcha={refreshReCaptcha}
        />

        <Layout>
          <Routes>
            {AppRoutes.map((route, index) => {
              const { element, ...rest } = route;
              return <Route key={index} {...rest} element={element} />;
            })}
          </Routes>
        </Layout>
      </GoogleReCaptchaProvider>
    );
  }
}
